import { useTitle } from 'react-use';

export const usePageTitle = (title: string) => {
  useTitle(`${title} | Upomínej`);
};
